<template>
  <v-container
    class="menu-component"
    fluid
    pa-0
    px-0>
    <div
      class="flex">
      <slot
        name="navbar"
        :navbar-mini="mini"/>
      <v-container
        id="components"
        class="main"
        :style="`margin-left: ${marginLeft}; --menu-width: ${menuWidth}px`">
        <TehMessageAlert/>
        <LowBalanceAlert/>
        <slot name="toolbar"/>
        <MenuComponentToolbar
          :custom_title="custom_title"
          :filtred_count="filtred_count"
          :style="isNavbar ? '' : 'max-width: 1024px; margin: 0 auto;'">
          <template #filter>
            <slot name="filter"/>
          </template>
          <template #filtered_items>
            <slot name="filtered_items"/>
          </template>
        </MenuComponentToolbar>
        <slot name="items"/>
        <slot name="loader"/>
      </v-container>
    </div>
  </v-container>
</template>
<script>
import LowBalanceAlert from 'components/billing/LowBalanceAlert.vue'
import TehMessageAlert from 'components/common/TehMessageAlert.vue'
import MenuComponentToolbar from 'components/common/blocks/MenuComponentToolbar.vue'

import displaySize from 'mixins/display-size'

export default {
  name: 'menuComponent',
  mixins: [ displaySize ],
  data() {
    return {
      mini: false
    }
  },
  methods: {
    changeState(val) {
      this.mini = val
    }
  },
  computed: {
    isNavbar() {
      // eslint-disable-next-line vue/no-deprecated-dollar-scopedslots-api
      return !!this.$scopedSlots.navbar
    },
    marginLeft() {
      return this.isNavbar && this.breakpoint.width < 936 ? '68px' : '0px'
    },
    menuWidth() {
      if (!this.isNavbar) {
        return 0
      }
      return this.mini || this.breakpoint.width < 936 ? 68 : 246
    }
  },
  components: {
    LowBalanceAlert,
    TehMessageAlert,
    MenuComponentToolbar
  },
  mounted() {
    this.$root.$on('changeSizeNavbar', this.changeState)
    const navBar = this.$children.find(child => child.$options.name === 'navBar')
    if (navBar) {
      this.changeState(navBar.mini)
    }
    let settings = this.$store.getters.getSettings,
      access = settings?.userAccess,
      checkBilling = access?.checkBillingResult
    if (checkBilling?.showMessageByPayment) {
      this.$root.$emit('showLowBilingAlert' )
    }
  },
  beforeDestroy() {
    this.$root.$off('changeSizeNavbar', this.changeState)
  },
  props: {
    custom_title: String,
    filtred_count: [Number, String, Boolean],
  },
}
</script>
<style lang="scss" scoped>
.menu-component {
  &.container, .container {
    position: relative;
  }
  .main {
    display: flex;
    height: calc(100vh - 64px);
    max-width: calc(100vw - var(--menu-width));
    overflow-y: auto;
    padding-bottom: 20px !important;
    padding-right: 28px !important;
    padding-left: 28px !important;
    flex-direction: column !important;
    background-color: var(--v-main__green-base) !important;
    position: relative;
    /*@media (min-width: 1240px) {
      max-width: 1240px;
      margin: auto !important;
    }*/
  }
  .mini-btn {
    position: fixed;
    bottom: 15px;
    left: 188px;
    z-index: 30;
    transition-duration: 0.25s;
    &.open {
      left: 17px;
    }
  }
}
</style>
